import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba 10 años tomando pastillas y pensando que era normal no dormir a mi edad. Este programa me enseñó que sí es posible descansar.',
  author: 'María',
  age: '72 años',
  location: 'Madrid'
}, {
  quote: 'Lo que más me gustó es que la letra es grande y las explicaciones son sencillas. No me sentí abrumado en ningún momento.',
  author: 'Roberto',
  age: '68 años',
  location: 'Valencia'
}, {
  quote: 'Mi hija me regaló este plan. Al principio dudé, pero en la tercera semana ya notaba que me despertaba con más energía.',
  author: 'Carmen',
  age: '75 años',
  location: 'Sevilla'
}];
export function Testimonials() {
  return <section className="py-24 bg-white border-t border-cream-100" data-id="element-132">
      <div className="container mx-auto px-6" data-id="element-133">
        <FadeIn data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 text-center mb-16" data-id="element-135">
            Historias de descanso real
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-136">
          {testimonials.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-137">
              <div className="bg-cream-50 p-8 rounded-2xl relative h-full flex flex-col" data-id="element-138">
                <Quote className="w-10 h-10 text-gold-500/40 mb-6" data-id="element-139" />
                <p className="text-xl text-navy-800 italic mb-8 flex-grow font-serif leading-relaxed" data-id="element-140">
                  "{item.quote}"
                </p>
                <div className="mt-auto border-t border-cream-200 pt-6" data-id="element-141">
                  <p className="font-bold text-navy-900 text-lg" data-id="element-142">
                    {item.author}
                  </p>
                  <p className="text-navy-600" data-id="element-143">
                    {item.age} • {item.location}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}